import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import Form, { AIAssistantFormMode } from "./Form";
import GenericDialog from "../GenericDialog";

const initialEntry = {
  name: "",
  description: "",
  instructions: "",
  deployment: "",
  codeInterpreter: false
};

export default function Create({ open, setOpen, onCreate }) {
  const { homeDispatch } = useContext(HomeAppContext);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  React.useEffect(() => {
    if (open) {
      setSubmitted(false);
      setErrors([]);
      setInternalEntry(initialEntry);
      setLoading(false);
    } else {
      setInternalEntry(null);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleCloseSave = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Saving AI Assistant", loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    const newAssistant = {
      name: internalEntry.name,
      description: internalEntry.description,
      instructions: internalEntry.instructions,
      model: internalEntry.deployment.id,
      codeInterpreter: internalEntry.codeInterpreter,
      files: internalEntry.files.map((f) => ({
        fileId: f.fileId,
        name: f.name
      }))
    };
    api
      .post(`/api/ai-assistants`, newAssistant)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Saved AI Assistant " + response.data.name,
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        onCreate();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={handleCloseSave}
        color="primary"
        variant="outlined"
        autoFocus
        disabled={loading || saveDisabled}
      >
        Save Assistant
      </Button>
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      title={"New AI Assistant"}
      actions={actions}
    >
        <Form
          mode={AIAssistantFormMode.NEW}
          entity={internalEntry}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
        />
    </GenericDialog>
  );
}
